import React from 'react';
import {render} from 'react-dom';
import {Provider, connect} from 'react-redux';
import {createStore} from 'redux';
import rootReducer from './new_order/reducers';
import fields from './new_order/fields';
import Form from './new_order/new_order_form';
import mapDispatchToProps from './new_order/map_dispatch_to_props';

const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));;
let brewery_data = JSON.parse(document.getElementById('brewery-data').getAttribute('data_value'));
let batchOptions = JSON.parse(document.getElementById('batch-options').getAttribute('data_value'));

const csfrToken = document.getElementsByName('csrf-token')[0];
const authenticationToken = csfrToken != null ? csfrToken.getAttribute('content') : '';


const initial_state = {
    brewery: brewery_data,
    batchOptions: batchOptions,
    samples: [],
    beers: [],
    fields: fields,
    other_options: {
        water_chemistry: {
            checked: false,
            cost: costMappings.water_chemistry,
        },
        water_chemistry_plus: {
            checked: false,
            cost: costMappings.water_chemistry_plus,
        },
    },
};

const store = createStore(rootReducer, initial_state);

function mapStateToProps(state) {
    return {
        store: state,
        authenticationToken: authenticationToken
    }
}

const ConnectedForm = connect(mapStateToProps, mapDispatchToProps)(Form);

class NewOrder extends React.Component {

    render() {
        return (
            <Provider store={store}>
                <ConnectedForm
                    clientFacing={this.props.client_facing}
                />
            </Provider>
        );
    }
}

export default NewOrder
